import { Component, OnInit } from '@angular/core';
import { VendorRequest } from '../models/vendor.model';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { SharedService } from '../services/shared-services';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-vendor-registration.component',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule, CommonModule,
    MatButtonModule],
  templateUrl: './vendor-registration.component.html',
  styleUrl: './vendor-registration.component.css'
})
export class VendorRegistrationComponent implements OnInit {
  registrationForm!: FormGroup;
  selectedForm: 'vendor' | 'employee' = 'vendor'; // default

  vendorForm!: FormGroup;
  employeeForm!: FormGroup;
  states: any[] = [];
  countries: any[] = [];
  districts: any[] = [];
  titles: any[] = [];
  tags: any[] = [];
  businessTypes: any[] = [];

  constructor(
    private fb: FormBuilder,
    private masterService: SharedService,
    //   this.vendorForm = this.fb.group({
    //   companyName: ['', Validators.required],
    //   address1: ['', Validators.required],
    //   buildingNumber: ['', Validators.required],
    //   // ... add all vendor form fields with validators
    // });

    // this.employeeForm = this.fb.group({
    //   employeeName: ['', Validators.required],
    //   employeeId: ['', Validators.required],
    //   email: ['', [Validators.required, Validators.email]],
    //   department: ['', Validators.required]
    // });
  ) { }

  ngOnInit(): void {
    this.masterService.getCountries().subscribe(res => {
      var countries = res;
      console.log('countries', countries);
    });


    this.vendorForm = this.fb.group({
      companyName: ['', Validators.required],
      address1: ['', Validators.required],
      address2: [''],
      buildingNumber: ['', Validators.required],
      additionalNumber: [''],
      stateId: ['', Validators.required],
      countryId: ['', Validators.required],
      districtId: ['', Validators.required],
      titleId: ['', Validators.required],
      tagIds: [[]],
      zipCode:['', Validators.required],
      vatNumber: ['', Validators.required],
      groupVatNumber: ['', Validators.required],
      commercialRegNo: ['', Validators.required],
      contactPerson: ['', Validators.required],
      city: ['', Validators.required],
      phone: ['', Validators.required],
      mobile: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      suppliedEarlier:['']
    });
    // this.vendorForm = this.fb.group({
    //   companyName: ['', Validators.required],
    //   address1: ['', Validators.required],
    //   buildingNumber: ['', Validators.required],
    //   // ... add all vendor form fields with validators
    // });

    this.employeeForm = this.fb.group({
      employeeName: ['', Validators.required],
      employeeId: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      department: ['', Validators.required]
    });
    // Load dropdowns
    // this.masterService.getStates().subscribe(res => this.states = res);
    // this.masterService.getCountries().subscribe(res => this.countries = res);
    //this.masterService.getDistricts().subscribe(res => this.districts = res);
    this.masterService.getTitles().subscribe(res => this.titles = res);
    // this.masterService.getTags().subscribe(res => this.tags = res);
  }
  submitVendorForm() {
    if (this.vendorForm.valid) {
      console.log('Vendor Registration:', this.vendorForm.value);
    }
  }

  submitEmployeeForm() {
    if (this.employeeForm.valid) {
      console.log('Employee Registration:', this.employeeForm.value);
    }
  }
  submitForm() {
    if (this.registrationForm.valid) {
      const formValue: VendorRequest = this.registrationForm.value;
      console.log('Final Payload:', formValue);
    }
  }
  onFileChange(event: any, controlName: string) {
    const file = event.target.files[0];
    if (file) {
      this.registrationForm.patchValue({ [controlName]: file });
    }
  }
}

